import React from "react";
import { GenericTableColumn } from "@ui-components/Table/GenericTable";
import { GenericTag } from "@ui-components/Tag/GenericTag";
import { format } from "date-fns";

export interface ThirdParty {
    id: string;
    clientName: string;
    projectId: string;
    linkType: string;
    purchaseOrder: string;
    projectName: string;
    origin: string;
    destination: string;
    capacity: string;
    vendorServiceReference: string;
    contractStartDate: string;
    contractEndDate: string;
    contractStatus: string;
    carrier: string;
    tenantId: string;
}

export interface CreateThirdPartyPortPayload {
    tenantId: string;
    providerId: string;
    vendorServiceReference: string;
    linkId: string;
    clientName?: string;
    projectId: string;
    linkType: string;
    purchaseOrder: string;
    projectName: string;
    origin: string;
    destination: string;
    capacity: string;
    contractStartDate: string;
    contractEndDate: string;
    contractStatus: string;
    carrier: string;
    localLoop: string;
    lastStateUpdate: string;
}

const getStatusVariant = (status: string): 'success' | 'warning' | 'error' | 'neutral' | 'default' => {
    switch (status?.toLowerCase()) {
        case 'active':
            return 'success';
        case 'finalized':
            return 'neutral';
        case 'pending':
            return 'warning';
        case 'cancelled':
            return 'error';
        default:
            return 'default';
    }
};

export const columns: GenericTableColumn<ThirdParty>[] = [
    {
        header: "ID de Enlace",
        accessor: "id",
        fixed: 'left',
        width: '100px'
    },
    {
        header: "Client",
        accessor: "clientName",
    },
    {
        header: "Project TD ID",
        accessor: "projectId",
    },
    {
        header: "Link Type",
        accessor: "linkType",
    },
    {
        header: "PO",
        accessor: "purchaseOrder",
    },
    {
        header: "Project Name",
        accessor: "projectName",
        renderCell: (row: ThirdParty) => (
            <div className="whitespace-pre-wrap max-w-[200px]">{row.projectName}</div>
        ),
        width: '200px'
    },
    {
        header: "Origin",
        accessor: "origin",
    },
    {
        header: "Destination",
        accessor: "destination",
    },
    {
        header: "Capacity",
        accessor: "capacity",
    },
    {
        header: "Vendor SR",
        accessor: "vendorServiceReference",
        renderCell: (row: ThirdParty) => (
            <div className="whitespace-pre-wrap max-w-[150px]">{row.vendorServiceReference}</div>
        ),
        width: '150px'
    },
    {
        header: "Contract Start Date",
        accessor: "contractStartDate",
        renderCell: (row: ThirdParty) => (
            row.contractStartDate ? format(new Date(row.contractStartDate), "yyyy-MM-dd") : ""
        ),
    },
    {
        header: "Contract End Date",
        accessor: "contractEndDate",
        renderCell: (row: ThirdParty) => (
            row.contractEndDate ? format(new Date(row.contractEndDate), "yyyy-MM-dd") : ""
        ),
    },
    {
        header: "Status",
        accessor: "contractStatus",
        width: '100px',
        renderCell: (row: ThirdParty) => (
            <GenericTag
                label={row.contractStatus}
                variant={getStatusVariant(row.contractStatus)}
            />
        )
    },
    {
        header: "Carrier",
        accessor: "carrier",
    },
    {
        header: "Actions",
        accessor: "id",
        fixed: 'right',
    }
];

